import React, { PropTypes as T } from 'react';

export default class Checkbox extends React.Component {
    static propTypes = {
        id : T.string,
        title : T.string,
        onChange: T.func.isRequired 
    };

    render() {
        var { id, checked, onChange, disabled } = this.props;

        return (
            <div className="b3-input-is-borked b3-checkbox-is-borked">
                <input type="checkbox" onChange={onChange} checked={checked} id={id} disabled={disabled} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/b3/inputs/Checkbox.js